import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { messages } from './locales/en/messages';
import Routes from './routes/Routes';
import EnvFrame from './components/EnvFrame/EnvFrame';
import ErrorBoundary from './components/ErrorBoundary';
import AuthErrorHandler from './components/AuthErrorHandler';

i18n.loadLocaleData('en', { plurals: 'en' });
i18n.load('en', messages);
i18n.activate('en');

function App() {
  return (
    <I18nProvider i18n={i18n}>
      {/* The router wraps everything: AuthErrorHandler navigates on a 401, and
          useNavigate only works inside a Router — @reach/router's navigate was
          a module-level function that worked anywhere. */}
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <div className="App">
          <AuthErrorHandler />
          <EnvFrame />
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
        </div>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
